import {getBlockingAsyncActionTypes} from './util';

export const CONFIG_TESTER__ACTIONSCOPE = 'CONFIG_TESTER_ACTION_SCOPE';

export const SET_DEPLOY_TYPE__ACTIONTYPE = 'SET_DEPLOY_TYPE';
export const SET_RATER_TYPE__ACTIONTYPE = 'SET_RATER_TYPE';
export const SET_DEPLOY_ERROR_MESSAGE__ACTIONTYPE = 'SET_DEPLOY_ERROR_MESSAGE';
export const DEPLOY_CONFIG__ACTIONTYPES = getBlockingAsyncActionTypes('DEPLOY_CONFIG');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/constants/config-tester.ts